import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { FinancialBalance } from "../../models/domains/pbm/financial-satatement/financial-balance";
import { SalesOrderResult } from "../../models/domains/pbm/financial-satatement/sales-order-result";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import { FindFinancialBalanceBySocialNumberParser } from "../parsers/pbm/financial-statement/financial-balance.parser";
import { FindFinancialStatementParser } from "../parsers/pbm/financial-statement/find-financial-statement.parse";
import { SearchFinancialStatement } from "../../models/domains/pbm/financial-satatement/search-financial-statement";

@Injectable()
export class FinancialStatementRepository {
  constructor(
    private remoteGatewayFactory: RemoteGatewayFactory,
    private findFinancialStatementParser: FindFinancialStatementParser,
    private findFinancialBalanceBySocialNumberParser: FindFinancialBalanceBySocialNumberParser,
  ) { }

  public async findFinancialStatement(searchFinancialStatement: SearchFinancialStatement): Promise<SalesOrderResult[]> {
    const headers = { "Content-Type": "application/json" };
    try {
      const data = await this.remoteGatewayFactory
        .createDefaultRemoteGateway()
        .postWithHeaders(new BackendUrl("/api/financial-statements"), searchFinancialStatement, headers);
      return this.findFinancialStatementParser.parse(data);
    } catch (referenceError) {
      let errorMessage = "Erro ao buscar extrato financeiro.";
      if(referenceError.error?.Data?.ErrorMessage) {
        errorMessage = referenceError.error.Data.ErrorMessage;
      }
      return await Promise.reject(errorMessage);
    }
  }

  public async findFinancialBalanceBySocialBalance(socialNumber: string, fiscalNumber: string): Promise<FinancialBalance> {
    const headers = {
      "Content-Type": "application/json",
    };
    const body = JSON.stringify({
      "fiscalNumber": {
        "value": fiscalNumber
      },
      "socialNumber": {
        "value": socialNumber
      }
    });

    try {
      const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
      const data = await remoteGateway.postWithHeaders(new BackendUrl("/api/financial-statements/balance"), body, headers);
      return this.findFinancialBalanceBySocialNumberParser.parse(data);
    } catch (referenceError) {
      const errorMessage = referenceError.error.Data.ErrorMessage;
      return await Promise.reject(errorMessage);
    }
  }
}
